import React from "react";
import { Button, Typography } from "@mui/material";
import { FileDownloadOutlined } from "@mui/icons-material";

const ToDownload = ({ params }: { params: { name: string; src: string } }) => {
  const handleDownloadClick = async () => {
    const response = await fetch(params.src);
    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = params.name;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };
  return (
    <Button
      sx={{
        display: "flex",
        alignItems: "center",
        p: "8px 16px",
        backgroundColor: "#E3F2FD",
        justifyContent: "space-around",
        color: "rgba(0, 0, 0, 0.87)",
        borderRadius: "4px",
        border: "1px solid rgba(25, 118, 210, 1)",
        width: "150px",
      }}
      onClick={handleDownloadClick}
    >
      <Typography variant="body2">Download</Typography>
      <FileDownloadOutlined
        fontSize="small"
        sx={{ color: "rgba(0, 0, 0, 0.54)" }}
      />
    </Button>
  );
};

export default ToDownload;
